import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PortalFrame, SignedOut } from '../../features/portal/shell'

/**
 * The contractor portal (slice 35). Its own layout: no staff chrome, and its own not-found screen so a mistyped portal
 * URL never offers a link into the staff app.
 */
export const Route = createFileRoute('/portal')({
  component: Outlet,
  notFoundComponent: () => (
    <PortalFrame>
      <SignedOut title="Nothing here" />
    </PortalFrame>
  ),
})
